class Rte {
    constructor(elm) {
        var $elm = $(elm);

        $elm.find('img')
            .attr('style', 'width: 100%');
    }
}

export default Rte;